import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/checklist";
import Bitcoin from "../assets/images/DeathModuleNew/Mining Bitcoin-1.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz1.png";
import editPen from "../assets/images/DeathModuleNew/editNotes.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import { Modal } from "antd";
import img1 from "../assets/images/DeathModuleNew/ad1.jpg";
import img2 from "../assets/images/DeathModuleNew/ad2.png";
import "./styledComponents/styles/checklist.css";
import { AdsContainer } from "./AdsContainer";
import { ToolTipCreator } from "../helpers/ToolTipCreator";

export const Checklist = (props) => {
  const CheckList = [
    {
      id: 1,
      Name: "Audio/Video Message",
      title: "audioVideoMessage",
      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 2,
      Name: "Checklist",
      title: "checklist",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 3,
      Name: "Personal Instructions",
      title: "personalInstructions",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 4,
      Name: "Contact list",
      title: "contactList",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 5,
      Name: "Important Documents",
      title: "importantDocument",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 6,
      Name: "Emails and Texts",
      title: "emailsToSend",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 11,
      Name: "List of Large Bills",
      title: "listOfLargeBills",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 7,
      Name: "Litigation List",
      title: "litigationList",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 8,
      Name: "Location of Personal items",
      title: "locationOfPersonalItems",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 9,
      Name: "List of Passwords",
      title: "listOfPasswords",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
    {
      id: 10,
      Name: "Funeral Wishes",
      title: "prepaidBurialExpenses",

      Radio: [
        { label: "Not Started" },
        { label: "Incomplete" },
        { label: "Complete" },
        { label: "Not Applicable" },
      ],
      showNotes: false,
    },
  ];
  const CheckListTrustee = [
    {
      id: 1,
      Name: "Audio/Video Message",
      title: "audioVideoMessage",
      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 2,
      Name: "Checklist",
      title: "checklist",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 3,
      Name: "Personal Instruction",
      title: "personalInstructions",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 4,
      Name: "Contact list",
      title: "contactList",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 5,
      Name: "Important Documents",
      title: "importantDocument",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 6,
      Name: "Email to Send",
      title: "emailsToSend",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 11,
      Name: "List of Large Bills",
      title: "listOfLargeBills",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 7,
      Name: "Litigation List",
      title: "litigationList",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 8,
      Name: "Location of Personal items",
      title: "locationOfPersonalItems",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 9,
      Name: "List Password",
      title: "listOfPasswords",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
    {
      id: 10,
      Name: "Funeral Wishes",
      title: "prepaidBurialExpenses",

      Radio: [{ label: "Incomplete" }, { label: "Complete" }],
      showNotes: false,
    },
  ];
  const CheckListYes = [
    {
      id: 1,
      Name: "Will",
      title: "will",
      Radio: [{ label: "Yes" }, { label: "No" }],
      showNotes: false,
    },
    {
      id: 2,
      Name: "Trust",
      title: "trust",
      Radio: [{ label: "Yes" }, { label: "No" }],
      showNotes: false,
    },
    {
      id: 3,
      Name: "Advanced Healthcare Directive",
      title: "advanceHealthDirectives",
      Radio: [{ label: "Yes" }, { label: "No" }],
      showNotes: false,
    },
  ];
  const imageList = [
    {
      id: 1,
      fileName: img1,
      name: "Professional Help",
      href: "https://www.legalzoom.com/marketing/estate-planning/living-trust?utm_source=google&utm_medium=cpc&utm_term=trusts%20legal%20zoom&utm_content=663551561683&utm_campaign=Brand%20|%20Consumer%20|%20Broad&utm_campaignID=19663909434&utm_adgroupID=147640949884&utm_partner=googlesearch&gclid=Cj0KCQjw4vKpBhCZARIsAOKHoWS7B-gYrHzTP5TXENpdYzbSnkbPY5reiHUcR5c8XY4UcIvvz-YSM0waAhIbEALw_wcB",
    },
    {
      id: 2,
      fileName: img2,
      name: "DIY Help",
      href: "https://trustandwill.com/?g_adtype=search&g_network=g&g_campaignid=6627564851&g_keyword=online%20wills%20and%20trusts&g_keywordid=kwd-4368701972&g_adid=426684965679&g_campaign=Trust%20%26%20Will%20%7C%20Non-Branded%20%7C%20MOFU&g_adgroupid=84278193532&g_acctid=740-480-2447&utm_campaign=trust_will_mofu&utm_source=google&utm_term=online%20wills%20and%20trusts&utm_medium=cpc&utm_content=426684965679&gad=1&gclid=Cj0KCQjw4vKpBhCZARIsAOKHoWQFEAn1k9mlQfbgAJNK3GjaxVw8mvWU6Y9QTF9u39ZogC3pLrzd1aUaAj1LEALw_wcB",
    },
  ];
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setUpdateShowModal] = useState(false);

  const [tooltipModal, setTooltipModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checklistform, setChecklistform] = useState({});
  const [clickedNotes, setClickedNotes] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [notes, setNotes] = useState(null);

  const [dropDownVal, setDropDownVal] = useState(null);

  const handelCloseModal = () => {
    setShowModal(false);
    setClickedNotes("");
  };
  const handelSaveNotes = async () => {
    setShowModal(false);
    let value = document.getElementById("notes").value;
    console.log("value", value, clickedNotes);

    let obj = { ...checklistform };
    console.log("before", obj);
    obj[clickedNotes] = value;
    console.log("after", obj);
    setChecklistform(obj);
    setLoading(true);

    await DEATH_API.upsertChecklist({
      ...obj,
    });
    setLoading(false);
    document.getElementById("notes").value = null;
    setClickedNotes("");
    setNotes(null);
  };
  const handelCloseUpdateModal = () => {
    setUpdateShowModal(false);
    setClickedNotes("");
  };
  const handelSaveUpdateNotes = async () => {
    let value = document.getElementById("UpdateNotes").value;
    console.log("value", value, clickedNotes);
    setUpdateShowModal(false);

    let obj = { ...checklistform };
    console.log("before", obj);
    obj[clickedNotes] = value;
    console.log("after", obj);
    setChecklistform(obj);
    setLoading(true);

    await DEATH_API.upsertChecklist({
      ...obj,
    });
    setLoading(false);
    setClickedNotes("");
    document.getElementById("UpdateNotes").value = null;
  };
  const handleDeleteNotes = async () => {
    console.log("clickedNotes", clickedNotes);

    // let obj = { ...checklistform };
    // console.log("before", obj);
    // obj[clickedNotes] = null;
    // console.log("after", obj);
    // setChecklistform(obj);
    // setLoading(true);

    // await DEATH_API.upsertChecklist({
    //   ...obj,
    // });
    // setLoading(false);
    // setClickedNotes("");
  };
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  useEffect(() => {
    console.log("calling api");
    getCheckList();
  }, []);

  const getCheckList = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchChecklist(ID);
      setLoading(false);

      if (data && data.data) {
        setChecklistform(data.data);

        // this.setState({
        //   checkListForm: { ...data.data },
        // });
      } else {
        setChecklistform({
          audioVideoMessage: "Not Started",
          checklist: "Not Started",
          contactList: "Not Started",
          emailsToSend: "Not Started",
          importantDocument: "Not Started",
          personalInstructions: "Not Started",
          listOfLargeBills: "Not Started",
          litigationList: "Not Started",
          locationOfPersonalItems: "Not Started",
          listOfPasswords: "Not Started",
          prepaidBurialExpenses: "Not Started",
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <div>
      {" "}
      <Modal closable={false} visible={showModal} centered footer={false}>
        <div>
          <h3 style={{ color: "#4d5e80" }}> Add Notes</h3>
          <textarea
            placeholder="Notes"
            defaultValue=""
            // value={""}
            id="notes"
            onChange={(e) => {
              setNotes(e.target.value);
            }}
            style={{
              outline: "none",
              width: "100%",
              border: "1px solid #D1D5DB",
              resize: "none",
              borderRadius: "5px",
              padding: "10px",
            }}></textarea>

          <Style.WrapperButtons>
            <Style.CancelButton
              id="stop"
              onClick={() => {
                handelCloseModal();
              }}>
              Cancel
            </Style.CancelButton>
            <Style.SaveButton
              id="stop"
              disabled={notes ? false : true}
              onClick={handelSaveNotes}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </div>
      </Modal>
      <Modal closable={false} visible={showUpdateModal} centered footer={false}>
        <div>
          <h3 style={{ color: "#4d5e80" }}> Update Notes</h3>
          <textarea
            placeholder="Notes"
            id="UpdateNotes"
            value={checklistform[clickedNotes] && checklistform[clickedNotes]}
            onChange={(e) => {
              console.log("evalue", e.target.value);
              let obj = { ...checklistform };
              console.log("before", obj);
              obj[clickedNotes] = e.target.value;
              console.log("after", obj);
              setChecklistform(obj);
            }}
            style={{
              outline: "none",
              width: "100%",
              border: "1px solid #D1D5DB",
              resize: "none",
              borderRadius: "5px",
              padding: "10px",
            }}></textarea>

          <Style.WrapperButtons>
            <Style.CancelButton
              id="stop"
              onClick={() => {
                handelCloseUpdateModal();
              }}>
              Cancel
            </Style.CancelButton>
            <Style.SaveButton id="stop" onClick={handelSaveUpdateNotes}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </div>
      </Modal>
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Checklist</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              For Plan Creators, the checklist functions as a scorecard
              reflecting those items yet to be completed or reviewed by each
              user. For Trusted Individuals the checklist functions as a
              dashboard to reflect those items in various stages of completion -
              or in some cases greyed- out - to reflect they are of no concern
              to this particular Plan Creator. Sometimes simple items like this
              greyed-out feature can reduce stress because people are less
              confused if this is an item of importance or of no concern.
            </Style.ModalDetails>
          </div>
          <div
            style={{
              display: "flex",
              height: "fit-content",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}>
            {tooltipModal && (
              <video style={{ width: "25rem" }} controls>
                <source
                  src={
                    "https://assets-planet.s3.amazonaws.com/media/283c2c31-8761-42f1-83f5-36b4b94ff1a7.mp4"
                  }
                  type="video/mp4"
                />
              </video>
            )}
          </div>
          {tooltipModal && (
            <div>
              <Style.ModalTitle style={{ float: "left", width: "100%" }}>
                Is yout Checklist completed? Congratulations!
              </Style.ModalTitle>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}>
                <video style={{ width: "25rem" }} controls>
                  <source
                    src={
                      "https://assets-planet.s3.amazonaws.com/media/db8578d3-609c-4635-acf8-0b7566ff8152.mp4"
                    }
                    type="video/mp4"
                  />
                </video>
              </div>{" "}
            </div>
          )}
        </div>
      </Modal>
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Bitcoin} alt="Bitcoin"></Style.HeaderImg> */}
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Checklist{" "}
          <ToolTipCreator name={"Death_Checklist"} />
        </div>
        {/* <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}></Style.HelpIcon> */}
      </Style.MainHeading>
      <Style.ChecklistCard>
        <Style.ChecklistCardHeader>
          <Style.Title style={{}}>Checklist</Style.Title>
        </Style.ChecklistCardHeader>
        {props.role !== "protrustee"
          ? CheckList.map((items, index) => (
              <Style.FileHeader key={index}>
                <Style.FileTitle style={{ width: "20%" }}>
                  {items.Name}:
                </Style.FileTitle>
                <div
                  style={{
                    display: "flex",
                    width: "80%",
                    justifyContent: "space-between",
                  }}>
                  {items.Radio &&
                    items.Radio.map(
                      (item, index) => (
                        console.log(item),
                        (
                          <label className="container1" key={index}>
                            <input
                              type="radio"
                              id={item.label}
                              value={item.label}
                              checked={
                                checklistform[items.title] === item.label
                              }
                              // defaultValue={"Not Started"}
                              // checked={checklistform[items.Name]===item.label}
                              onChange={async (e) => {
                                let obj = { ...checklistform };
                                console.log("before", obj);
                                obj[items.title] = item.label;
                                console.log("after", obj);
                                setChecklistform(obj);
                                setLoading(true);

                                await DEATH_API.upsertChecklist({
                                  ...obj,
                                });
                                setLoading(false);
                              }}
                            />
                            <span id={item.label} className="checkmark"></span>
                            {item.label}
                          </label>
                        )
                      )
                    )}

                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#F4F7FE",
                      cursor: "pointer",
                      // width: "30px",
                      // height: "30px",
                    }}>
                    {" "}
                    {checklistform[items.title + "Notes"] ? null : (
                      <img
                        style={{
                          marginLeft: "6px",
                          marginTop: "6px",
                          marginRight: "6px",
                        }}
                        onClick={() => {
                          setShowModal(true);
                          setClickedNotes(items.title + "Notes");
                          console.log("clicked notes", items.title + "Notes");
                          console.log("title", items.title);
                        }}
                        src={editPen}
                        alt="editPen"></img>
                    )}
                  </div>
                </div>
                {checklistform[items.title + "Notes"] && (
                  <div
                    style={{
                      backgroundColor: "#f4f7fe",
                      fontSize: "12px",
                      width: "100%",
                      padding: "10px",
                      marginTop: "4px",
                    }}>
                    <div style={{ color: "#99A1B3", fontFamily: "Poppins" }}>
                      Notes
                    </div>
                    <div
                      style={{
                        backgroundColor: "#f4f7fe",
                        fontSize: "12px",
                        width: "100%",
                        marginTop: "4px",
                        display: "flex",
                      }}>
                      {" "}
                      <div
                        style={{
                          color: "#99A1B3",
                          fontFamily: "Poppins",
                          width: "40%",
                        }}>
                        {" "}
                        {checklistform[items.title + "Notes"]}
                      </div>
                      <div>
                        <img
                          style={{ cursor: "pointer", marginLeft: "8px" }}
                          src={SeeMore}
                          alt="seemore"
                          onClick={() => {
                            setDropdown(!dropdown);
                            setDropDownVal(items.title);
                            console.log(
                              "check",
                              Object.keys(checklistform).map((val) => {
                                if (val === items.title) {
                                  return true;
                                }
                              })
                            );

                            console.log(
                              "dropdown open",
                              Object.keys(checklistform).map((val) => val),
                              items.title,
                              checklistform.hasOwnProperty(items.title)
                            );
                          }}></img>
                        {dropdown &&
                          checklistform &&
                          dropDownVal === items.title && (
                            <>
                              <div
                                onClick={() => {
                                  setDropdown(false);
                                }}
                                className=""
                                style={{
                                  position: "fixed",
                                  width: "100vw",
                                  height: "100vh",
                                  background: "black",
                                  opacity: "0.1",
                                  top: "0",
                                  left: "0",
                                  right: "0",
                                  bottom: "0",
                                  zIndex: "999",
                                }}></div>

                              <div
                                className="dropdownNotes"
                                style={{ zIndex: "9999" }}>
                                <ul className="dropdownul">
                                  <li
                                    className="liHover"
                                    onClick={async () => {
                                      let obj = { ...checklistform };
                                      console.log("before", obj);
                                      obj[items.title + "Notes"] = null;
                                      console.log("after", obj);
                                      setChecklistform(obj);
                                      setLoading(true);
                                      await DEATH_API.upsertChecklist({
                                        ...obj,
                                      });
                                      setLoading(false);
                                      setDropdown(false);
                                    }}>
                                    Delete
                                  </li>
                                  <li
                                    className="liHover"
                                    onClick={() => {
                                      setDropdown(false);
                                      setClickedNotes(items.title + "Notes");
                                      setUpdateShowModal(true);
                                    }}>
                                    Update
                                  </li>
                                </ul>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                )}
              </Style.FileHeader>
            ))
          : CheckListTrustee.map((items, index) => (
              <Style.FileHeader key={index}>
                <Style.FileTitle style={{ width: "20%" }}>
                  {items.Name}:
                </Style.FileTitle>
                <div
                  style={{
                    display: "flex",
                    width: "80%",
                    justifyContent: "space-between",
                  }}>
                  {items.Radio &&
                    items.Radio.map(
                      (item, index) => (
                        console.log(item),
                        (
                          <label className="container1" key={index}>
                            <input
                              type="radio"
                              id={item.label}
                              value={item.label}
                              checked={
                                checklistform[items.title] === item.label
                              }
                              // defaultValue={"Not Started"}
                              // checked={checklistform[items.Name]===item.label}
                              onChange={async (e) => {
                                let obj = { ...checklistform };
                                console.log("before", obj);
                                obj[items.title] = item.label;
                                console.log("after", obj);
                                setChecklistform(obj);
                                setLoading(true);

                                await DEATH_API.upsertChecklist({
                                  ...obj,
                                });
                                setLoading(false);
                              }}
                            />
                            <span id={item.label} className="checkmark"></span>
                            {item.label}
                          </label>
                        )
                      )
                    )}

                  <div
                    style={{
                      borderRadius: "50%",
                      background: "#F4F7FE",
                      cursor: "pointer",
                      // width: "30px",
                      // height: "30px",
                    }}>
                    {" "}
                    {checklistform[items.title + "Notes"] ? null : (
                      <img
                        style={{
                          marginLeft: "6px",
                          marginTop: "6px",
                          marginRight: "6px",
                        }}
                        onClick={() => {
                          setShowModal(true);
                          setClickedNotes(items.title + "Notes");
                          console.log("title", items.title);
                        }}
                        src={editPen}
                        alt="editPen"></img>
                    )}
                  </div>
                </div>
                {checklistform[items.title + "Notes"] && (
                  <div
                    style={{
                      backgroundColor: "#f4f7fe",
                      fontSize: "12px",
                      width: "100%",
                      padding: "10px",
                      marginTop: "4px",
                    }}>
                    <div style={{ color: "#99A1B3", fontFamily: "Poppins" }}>
                      Notes
                    </div>
                    <div
                      style={{
                        backgroundColor: "#f4f7fe",
                        fontSize: "12px",
                        width: "100%",
                        marginTop: "4px",
                        display: "flex",
                      }}>
                      {" "}
                      <div
                        style={{
                          color: "#99A1B3",
                          fontFamily: "Poppins",
                          width: "40%",
                        }}>
                        {" "}
                        {checklistform[items.title + "Notes"]}
                      </div>
                      <div>
                        <img
                          style={{ cursor: "pointer", marginLeft: "8px" }}
                          src={SeeMore}
                          alt="seemore"
                          onClick={() => {
                            setDropdown(!dropdown);
                            setDropDownVal(items.title);
                            console.log(
                              "check",
                              Object.keys(checklistform).map((val) => {
                                if (val === items.title) {
                                  return true;
                                }
                              })
                            );

                            console.log(
                              "dropdown open",
                              Object.keys(checklistform).map((val) => val),
                              items.title,
                              checklistform.hasOwnProperty(items.title)
                            );
                          }}></img>
                        {dropdown &&
                          checklistform &&
                          dropDownVal === items.title && (
                            <>
                              <div
                                onClick={() => {
                                  setDropdown(false);
                                }}
                                className=""
                                style={{
                                  position: "fixed",
                                  width: "100vw",
                                  height: "100vh",
                                  background: "black",
                                  opacity: "0.1",
                                  top: "0",
                                  left: "0",
                                  right: "0",
                                  bottom: "0",
                                  zIndex: "999",
                                }}></div>

                              <div
                                className="dropdownNotes"
                                style={{ zIndex: "9999" }}>
                                <ul className="dropdownul">
                                  <li
                                    className="liHover"
                                    onClick={async () => {
                                      let obj = { ...checklistform };
                                      console.log("before", obj);
                                      obj[items.title + "Notes"] = null;
                                      console.log("after", obj);
                                      setChecklistform(obj);
                                      setLoading(true);
                                      await DEATH_API.upsertChecklist({
                                        ...obj,
                                      });
                                      setLoading(false);
                                      setDropdown(false);
                                    }}>
                                    Delete
                                  </li>
                                  <li
                                    className="liHover"
                                    onClick={() => {
                                      setDropdown(false);
                                      setClickedNotes(items.title + "Notes");
                                      setUpdateShowModal(true);
                                    }}>
                                    Update
                                  </li>
                                </ul>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                )}
              </Style.FileHeader>
            ))}
      </Style.ChecklistCard>
      <Style.ChecklistCard style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ width: "50%" }}>
          {CheckListYes.map((items, index) => (
            <Style.FileHeaderYes
              key={index}
              style={{ justifyContent: "space-between" }}>
              <Style.FileTitle style={{ width: "20%" }}>
                {items.Name}:
              </Style.FileTitle>
              <div
                style={{
                  display: "flex",
                  width: "60%",
                  justifyContent: "space-between",
                }}>
                {items.Radio &&
                  items.Radio.map((item, index) => (
                    <label class="container1" key={index}>
                      <input
                        type="radio"
                        id={item.label}
                        value={item.label}
                        checked={checklistform[items.title] === item.label}
                        onChange={async (e) => {
                          let obj = { ...checklistform };
                          console.log("before", obj);
                          obj[items.title] = item.label;
                          console.log("after", obj);
                          setChecklistform(obj);
                          setLoading(true);

                          await DEATH_API.upsertChecklist({
                            ...obj,
                          });
                          setLoading(false);
                        }}
                      />
                      <span class="checkmark"></span>
                      {item.label}
                    </label>
                  ))}
              </div>
            </Style.FileHeaderYes>
          ))}
        </div>
        <div
          style={{
            width: "50%",
            background: "white",
            borderRadius: "8px",
            overflow: "hidden",
            marginTop: "1rem",
          }}>
          <AdsContainer images={imageList} name="Checklist" />
        </div>
      </Style.ChecklistCard>
      <Style.MessageCard>
        <Style.Title style={{}}>Reasons/Importance</Style.Title>
        <div style={{ marginTop: "1rem" }}>
          <Style.Messages style={{ fontWeight: "normal" }}>
            <strong style={{ textDecoration: "underline" }}>
              <em>AHCD</em>
            </strong>{" "}
            communicates to medical professionals your personal wishes if you
            are incapacitated. This document removes guessing and delays based
            on your intentions and cannot be overridden by others. A{" "}
            <strong style={{ textDecoration: "underline" }}>
              <em>Will</em>
            </strong>{" "}
            may or may not be considered a legal document in your state or
            jurisdiction. If done properly, a Will does provide written intent
            for the creator. Courts and financial institutions might not accept
            a Will, which can be challenged or rejected. A{" "}
            <strong style={{ textDecoration: "underline" }}>
              <em>Trust</em>
            </strong>{" "}
            is a legal document that allows for specific instructions and intent
            that financial institutions recognize. For assets to be properly
            held, they must have the Trust as the titled owner. A proper Trust
            should avoid probate and extra headaches and is recommended for
            anyone with assets or estate complexity.
          </Style.Messages>
        </div>
      </Style.MessageCard>
      <Loader isLoading={loading} />
    </div>
  );
};
